"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletSDKRelayAbstract = exports.APP_VERSION_KEY = exports.LOCAL_STORAGE_ADDRESSES_KEY = exports.WALLET_USER_NAME_KEY = void 0;

var eth_rpc_errors_1 = require("eth-rpc-errors");

exports.WALLET_USER_NAME_KEY = "walletUsername";
exports.LOCAL_STORAGE_ADDRESSES_KEY = "Addresses";
exports.APP_VERSION_KEY = "AppVersion";

var WalletSDKRelayAbstract = /*#__PURE__*/function () {
  function WalletSDKRelayAbstract() {
    _classCallCheck(this, WalletSDKRelayAbstract);
  }

  _createClass(WalletSDKRelayAbstract, [{
    key: "makeEthereumJSONRPCRequest",
    value: function () {
      var _makeEthereumJSONRPCRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(request, jsonRpcUrl) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (jsonRpcUrl) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Error: No jsonRpcUrl provided");

              case 2:
                return _context.abrupt("return", window.fetch(jsonRpcUrl, {
                  method: "POST",
                  body: JSON.stringify(request),
                  mode: "cors",
                  headers: {
                    "Content-Type": "application/json"
                  }
                }).then(function (res) {
                  return res.json();
                }).then(function (json) {
                  if (!json) {
                    throw eth_rpc_errors_1.ethErrors.rpc.parse({});
                  }

                  var response = json;
                  var error = response.error;

                  if (error) {
                    throw (0, eth_rpc_errors_1.serializeError)(error);
                  }

                  return response;
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function makeEthereumJSONRPCRequest(_x, _x2) {
        return _makeEthereumJSONRPCRequest.apply(this, arguments);
      }

      return makeEthereumJSONRPCRequest;
    }()
  }]);

  return WalletSDKRelayAbstract;
}();

exports.WalletSDKRelayAbstract = WalletSDKRelayAbstract;